// Which rows of the Deactivate screen can be ticked: only people still on the books.
// People already marked Exited have no Deactivate button, so select-all must skip them too.
export function selectableIds(employees) {
  return (employees || []).filter((employee) => employee.status !== "Exited").map((employee) => employee.id);
}

// True only when there is something to tick and every tickable row is ticked.
export function allSelected(employees, selected) {
  const ids = selectableIds(employees);
  return ids.length > 0 && ids.every((id) => selected.has(id));
}
